export function parse (string, recoverFromBadThings) {
  if (string) {
    try {
      return JSON.parse(string)
    } catch (e) {
      recoverFromBadThings()
    }
  }
}
